import { jsx, jsxs } from 'react/jsx-runtime';
import { Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio as Radio$1 } from '@mui/material';

const Radio = ({ label, options, value, name, handleChange, }) => {
    return (jsx(Grid, Object.assign({ item: true, lg: 6, md: 12, sm: 12, xs: 12 }, { children: jsxs(FormControl, Object.assign({ component: "fieldset", variant: "standard" }, { children: [jsx(FormLabel, Object.assign({ component: "legend" }, { children: label })), jsx(RadioGroup, Object.assign({ name: "gender1", value: "", onChange: () => { }, row: true }, { children: options.map((answer, index) => {
                        return (jsx(FormControlLabel, { value: answer.Resposta, control: jsx(Radio$1, { checked: value === answer.Resposta, onChange: handleChange, name: `${name}` }), label: answer.Resposta }, `${answer.Resposta}-${index}`));
                    }) }))] })) })));
};

export { Radio };
